import { X_TRACE_ID_HEADER } from '../config';
import Utils from '../helpers/utils';
import { v4 as uuidv4 } from 'uuid';

class BaseServices {
  constructor(config) {
    this.config = config || {};
    this.logger = this.config.logger || console;
    this.traceIdHeader = X_TRACE_ID_HEADER;
  }

  includeTraceIdHeader() {
    if (!Utils.isServerSide()) {
      // remove traceId if and only if it was added in this method
      window._removeTraceIdLater = !window[this.traceIdHeader];
      window[this.traceIdHeader] = window[this.traceIdHeader] || uuidv4();
    }
  }

  removeTraceIdHeader() {
    if (!Utils.isServerSide()) {
      if (window._removeTraceIdLater) {
        window[this.traceIdHeader] = undefined;
        window._removeTraceIdLater = false;
      }
    }
  }

  async traceIdDecorator(clientFunction) {
    this.includeTraceIdHeader();
    try {
      const resp = await clientFunction();
      this.removeTraceIdHeader();
      return resp;
    } catch (e) {
      this.removeTraceIdHeader();
      throw e;
    }
  }
}

export { BaseServices };
